import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { ToastContainer, toast } from "react-toastify";

const EmployeeScoreView = () => {
  const { summaryId } = useParams();
  const history = useHistory();

  const [summary, setSummary] = useState(null);
  const [questions, setQuestions] = useState([]);
const totalScore =
  summary?.total_score ??
  questions.reduce((sum, q) => sum + Number(q.score || 0), 0);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/employees-appraisal/score/${summaryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        setSummary(res.data.summary);
        setQuestions(res.data.questions || []);
      })
      .catch(() => toast.error("Failed to load score"));
  }, [summaryId]);

  if (!summary) {
    return <div className="card p-4">Loading...</div>;
  }

  return (
    <div className="card">
      <ToastContainer />

      {/* HEADER */}
      <div className="card-header d-flex justify-content-between">
        <h5>Appraisal Score</h5>
        <button className="btn btn-primary" onClick={() => history.goBack()}>
          Back
        </button>
      </div>

      {/* EMPLOYEE INFO */}
      <div className="card-body bg-light">
        <h6>
          {summary.employee_id} - {summary.emp_name}
        </h6>
        <p>{summary.designation_name}</p>
        <p>{summary.department_name}</p>
        <h4 className="text-danger">
  Total Score : {totalScore}
</h4>

      </div>

      {/* QUESTIONS */}
      <div className="card-body">
        {questions.length === 0 ? (
          <p>No questions found</p>
        ) : (
          questions.map((q, i) => (
            <div key={i} className="mb-3">
              <h6 style={{ color: "#ea4e1b" }}>
                {i + 1}. {q.question_title}
              </h6>

              <p style={{ marginLeft: 20, color: "#25ce3f", fontWeight: "bold" }}>
                {q.value_title} (Score: {q.score})
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EmployeeScoreView;
